
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import getUAString from '../utils/userAgent.js';

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

export { isLayoutViewport as default };
//# sourceMappingURL=isLayoutViewport.js.map
